import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export type ColorSchema = 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'error';

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    neutral: string;
  }
  interface SimplePaletteColorOptions {
    lighter: string;
    darker: string;
  }
  interface PaletteColor {
    lighter: string;
    darker: string;
  }

  // if you want to add a new color to the palette, you can do it here
  interface Palette {
    insurance: {
      primary: string;
      secondary: string;
      tertiary: string;
    };
  }
  interface PaletteOptions {
    insurance?: {
      primary?: string;
      secondary?: string;
      tertiary?: string;
    };
  }
}


export const padding = {
  paddingX: 3,
}

// SETUP COLORS

export const grey = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

export const primary = {
  lighter: '#F5E9D4',
  light: '#E2C78E',
  main: '#CFA554',
  dark: '#B88A2A',
  darker: '#8C6A1F',
  contrastText: '#FFFFFF',
};

export const secondary = {
  lighter: '#E8E9E6',
  light: '#A5A79D',
  main: '#828573',
  dark: '#5F6154',
  darker: '#3C3D35',
  contrastText: '#FFFFFF',
};

// TODO: switch these back to original colors
export const info = {
  lighter: '#CAFDF5',
  light: '#61F3F3',
  main: '#00B8D9',
  dark: '#006C9C',
  darker: '#003768',
  contrastText: '#FFFFFF',
};

export const success = {
  lighter: '#D3FCD2',
  light: '#77ED8B',
  main: '#22C55E',
  dark: '#118D57',
  darker: '#065E49',
  contrastText: '#ffffff',
};

export const warning = {
  lighter: '#FFF5CC',
  light: '#FFD666',
  main: '#FFAB00',
  dark: '#B76E00',
  darker: '#7A4100',
  contrastText: grey[800],
};

export const error = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
};

export const common = {
  black: '#000000',
  white: '#FFFFFF',
};

export const insurance = {
  primary: '#E6C200',
  secondary: '#B0B7C3',
  tertiary: '#A97142',
}

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  insurance,
  divider: alpha(grey[500], 0.2),
  action,
};

// ----------------------------------------------------------------------

export function palette(mode: 'light' | 'dark') {
  const light = {
    ...base,
    mode: 'light',
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    background: {
      paper: '#FFFFFF', // TODO: this is the color paper
      default: '#F5F0EB', // TODO: this is site background
      neutral: grey[200],
    },
    action: {
      ...base.action,
      active: grey[600],
    },
  };

  // const dark = {
  //   ...base,
  //   mode: 'dark',
  //   text: {
  //     primary: '#FFFFFF',
  //     secondary: grey[500],
  //     disabled: grey[600],
  //   },
  //   background: {
  //     paper: grey[800],
  //     default: grey[900],
  //     neutral: alpha(grey[500], 0.12),
  //   },
  //   action: {
  //     ...base.action,
  //     active: grey[500],
  //   },
  // };
  return light;
  // return mode === 'light' ? light : dark;
}
